import { Input, InputProps, InputRef } from 'antd'
import classNames from 'classnames'
import React from 'react'

type TextFieldProps = InputProps & {
  ddActionName?: string
}

export const TextField = React.memo(
  React.forwardRef<InputRef, TextFieldProps>(({ name, size = 'large', className, ddActionName, ...rest }, ref) => (
    <Input
      ref={ref}
      id={name}
      data-dd-action-name={ddActionName}
      data-testid={name}
      size={size}
      className={classNames('w-full', className)}
      {...rest}
    />
  )),
)

TextField.displayName = 'TextField'
